import React, {useState, useEffect} from "react";
import classNames from "classnames"
import { Input } from "antd";
import {debounce} from "lodash";
import {hasBeenFilled} from "../../../helpers/dynamicFormHelper";

interface PropsType {
  name: string,
  defaultValue: string,
  className?: string,
  placeholder?: string,
  allowClear?: boolean,
  disabled: boolean,
  onChange: any
}

const InputText = (props: PropsType) => {
  const {
    name,
    className,
    defaultValue,
    placeholder,
    allowClear,
    disabled,
    onChange
  } = props;

  const [value, setValue] = useState(defaultValue);
  useEffect(() => {
    setValue(defaultValue);
    return () => {};
  }, [defaultValue]);

  const isInputDisabled = disabled && hasBeenFilled(defaultValue);

  const onChangeHandler = (e) => {
    e.persist();
    setValue(e.target.value);
    return debounce((event) => {
      onChange(event);
    }, 500)(e);
  };

  return (
    <Input
      name={name}
      type="text"
      allowClear={allowClear}
      value={value}
      onChange={onChangeHandler}
      className={classNames("m-0 form-control", className)}
      placeholder={placeholder}
      disabled={isInputDisabled}
    />
  );
};

export default InputText;
